import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy path for the Wealth Signals stub — now lives at /events.
export const Route = createFileRoute('/cases')({
  beforeLoad: () => {
    throw redirect({ to: '/events' });
  },
});
